module.exports = __webpack_public_path__ + "static/media/date-end.9c91cb3d.svg";